<template>
    <div>
        <page-header :heading="pageHeader.title"
                     :buttons="pageHeader.buttons" />

        <!--<search-form key="formUserSearch"
                     :inputs="searchInputsEx"
                     class="mb-5"
                     @clear="handleClearClick"
                     @search="handleSearchClick" />
        <hr />-->
        <div class="row">
            <div class="col-lg">
                <div class="row">
                    <div class="col-4">
                        <page-size v-model="pageSize"
                                   @input="handleSearchClick(searchPayload)" />
                    </div>
                    <div class="col">
                        <order-by v-model="selectedOrderBy"
                                  :options="orderByOptions"
                                  @goClick="handleOrderByClick" />
                    </div>
                </div>
                <data-list :dataCols="repairOptionInstructionCols"
                           :dataListItems=" repairOptionInstructions"
                           :tableClass="'table table-striped table-sm'" 
                           @sgl-click="handleItemSglClick"/>
                <b-pagination align="center"
                              size="md"
                              :total-rows="totalRecords"
                              v-model="pageNumber"
                              :per-page="pageSize"
                              @input="handlePagenationInput" />
            </div>
            <div class="col-lg">
                <b-card no-body>
                    <b-tabs card>
                        <b-tab title="Preview" active>
                            <div v-html="selectedOptionInstructions.instructionsHTML"></div>
                        </b-tab>
                        <b-tab title="RAW">
                            <textarea 
                                class="form-control" 
                                id="instructionRaw" 
                                rows="3" 
                                v-model="selectedOptionInstructions.instructionsHTML" 
                                disabled></textarea>
                        </b-tab>
                    </b-tabs>
                </b-card>
            </div>
        </div>
            <loading :active.sync="isLoading"
                     :can-cancel="false"
                     :is-full-page="true"></loading>
    </div>
</template>

<script>

import OrderBy from '@/components/OrderBy.vue'
import PageHeader from '@/components/PageHeader.vue'
import DataList from '@/components/DataList.vue'
//import DataListCSV from '@/components/DataListCSV.vue'


import PageSize from '@/components/PageSize.vue'
//import SearchForm from '@/components/SearchForm.vue'

import { searchInputs } from '@/ui.config/inputs/formUserSearchInputs'
import { repairOptionInstructionCols } from '@/ui.config/cols/repairOptionCols'

import { mapActions } from 'vuex'

import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';

export default {
    name:'repairOptionsInstructions',
    mixins: [

    ],
    components: {
        PageHeader,
        DataList,
        //'data-list-csv': DataListCSV,
        PageSize,
        //SearchForm,
        Loading,
        OrderBy
    },
    data: () => {
        return {
            pageHeader: {
                title: 'Repair Options - Instructions',
            },

            searchInputs: searchInputs,
            repairOptionInstructionCols: repairOptionInstructionCols,

            searchPayload: null,
            orderBy: 'DateCreated',
            sortDirection: 'DESC',

            selectedOrderBy: null,

            // Override mixin
            orderByOptions: [
                {
                    id: 0,
                    key: 'ProviderName',
                    label: 'Provider Name'
                },
                {
                    id: 1,
                    key: 'OptionTypeLabel',
                    label: 'Option Type'
                }
            ],
        }
    },
    beforeMount() {
        this.fetchRepairOptionInstructions({})
        this.fetchResellers()
        this.setSelectedOptionInstructions({})
    },
    computed: {
        isLoading() {
            return this.$store.getters.isLoading
        },
        pageNumber: {
            get() {
                return this.$store.getters.pageNumber
            },
            set(value) {
                this.$store.commit('setPageNumber', value)
            }
        },
        totalRecords() {
            return this.$store.getters.totalRecords
        },
        pageSize: {
            get() {
                return this.$store.getters.pageSize
            },
            set(value) {
                this.$store.commit('setPageSize', value)
            }
        },
        repairOptionInstructions() {
            return this.$store.getters.repairOptionInstructions
        },
        selectedOptionInstructions() {
            return this.$store.getters.selectedOptionInstructions
        },
        searchInputsEx() {
            var { resellers, searchInputs } = this

            if (searchInputs && searchInputs.length > 0) {
                if (resellers) {
                    searchInputs[0].options = resellers
                }
            }
            return searchInputs
        },
        resellers() {
            return this.$store.getters.resellers
        },
    },
    methods: {
        ...mapActions([
            'fetchRepairOptionInstructions',
            'fetchResellers',
            'setSelectedOptionInstructions'
        ]),
        handleItemSglClick(payload) {
            this.setSelectedOptionInstructions({})
            this.setSelectedOptionInstructions(payload[0])
        },
        handlePagenationInput(payload) {
            let criteria = this.buildSearchCriteria(this.buildSearchValues(this.searchPayload))
            this.search(criteria, payload)
        },
        handleOrderByClick(payload) {
            let { orderBy, direction } = payload
            if ((typeof (orderBy) != 'undefined' && orderBy != null) &&
                (typeof (orderBy) != 'undefined' && orderBy != null)) {

                this.orderBy = orderBy.key
                this.sortDirection = direction
                this.handleSearchClick(this.searchPayload)
            }
        },
        handleSearchClick(payload) {
            if (payload != null) {
                this.searchPayload = payload

                let criteria = this.buildSearchValues(payload)

                this.search(criteria, 1)
            } else {
                this.search(null, 1)
            }
        },
        handleClearClick() {

            this.search(null, 1)
        },
        buildSearchValues(payload) {
            if (payload != null) {
                let { reseller, emailAddress } = payload

                let criteria = {
                    resellerId: reseller ? reseller.id : null,
                    emailAddress: emailAddress
                }

                return criteria
            } else {
                return null
            }
        },
        buildSearchCriteria(searchValues, pageNumber) {
            let ordering = {
                orderBy: this.orderBy,
                sortDirection: this.sortDirection
            }

            let pages = {
                pageSize: this.pageSize,
                pageNumber: pageNumber
            }

            let criteria = {
                ...searchValues,
                ...ordering,
                ...pages
            }

            return criteria
        },
        search(searchValues, pageNumber) {
            //this.clearClaimsList()

            let criteria = this.buildSearchCriteria(searchValues, pageNumber)

            this.fetchRepairOptionInstructions(criteria)
        }
    }
}
</script>

<style>
</style>
